import { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Seite.css";

// 🔹 массив с данными для schema.org
const videos = [
  {
    name: "Официальный сайт Сергея Мавроди",
    description: "Видеопрезентация официального сайта Сергея Мавроди.",
    thumbnailUrl: "/video/24.webp",
    contentUrl: "/video/24.mp4",
    uploadDate: "2024-03-01T00:00:00+03:00",
    duration: "PT35S"
  },
  {
    name: "Предупреждение от Сергея Мавроди",
    description: "Видео с предупреждением Сергея Мавроди о мошенниках.",
    thumbnailUrl: "/video/42.webp",
    contentUrl: "/video/42.mp4",
    uploadDate: "2024-03-03T00:00:00+03:00",
    duration: "PT21S"
  }
];


// Компонент предупреждения
const WarningMessage = () => (
  <div className="main_fon">
    <div className="main_fon_text">
              <p><span style={{ fontWeight: "bold", fontSize: "131%", color: ' rgb(255, 0, 0)' }}>
          ПРЕДУПРЕЖДЕНИЕ!
          <br /><br />
        </span>
        <span style={{ fontSize: "111%" }}>
            Тексты, фото-, видео- и различные Материалы, размещённые на Официальном сайте Сергея Мавроди, предназначены только для частного просмотра и изучения.<br /><br />
            Несанкционированное использование содержимого Сайта  полностью или частично, изготовление копий, распространение, публичный показ, сообщение в эфир, размещение на иных Ресурсах или в сети Интернет, а также любыми другими способами —  недопустимо без указания Источника: <a href="https://sergey-mavrodi.com">sergey-mavrodi.com</a>
            <br /><br />
            Нарушение влечет гражданскую, административную или уголовную ответственность в соответствии с Законодательством.
          </span></p>
      
    </div>
  </div>
);

// Основной компонент
const Seite = () => {
  const [isFirstVideoLoaded, setIsFirstVideoLoaded] = useState(false);
  const [isSecondVideoLoaded, setIsSecondVideoLoaded] = useState(false);

  return (
    <div className="content">
      
<Helmet>
  <title>Официальный сайт Сергея Мавроди: Творчество, Новости, KinoTheater</title>
  <meta
    name="description"
    content="Официальный сайт Сергея Мавроди: новости, творчество, видео, книги и архивные материалы."
  />
  <meta name="keywords" content="Сергей Мавроди, МММ, новости, видео, творчество, книги" />
  <meta name="author" content="Сергей Мавроди" />
  <meta property="og:title" content="Главная - Сергей Мавроди" />
  <meta
    property="og:description"
    content="Официальный сайт Сергея Мавроди: новости, видео, творчество и архив."
  />
  <meta property="og:image" content="https://sergey-mavrodi.com/portrait.webp" />
  <meta property="og:url" content="https://sergey-mavrodi.com/" />
  <meta property="og:type" content="website" />
  <meta property="og:locale" content="ru_RU" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Главная - Сергей Мавроди" />
  <meta
    name="twitter:description"
    content="Официальный сайт Сергея Мавроди: новости, видео, творчество."
  />
  <meta name="twitter:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
  <link rel="canonical" href="https://sergey-mavrodi.com/" />

  {/* --- Schema.org: WebPage --- */}
  <script type="application/ld+json">
    {JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      'name': 'Главная страница',
      'description': 'Официальный сайт Сергея Мавроди: новости, видео, творчество.',
      'url': 'https://sergey-mavrodi.com/',
      'image': 'https://sergey-mavrodi.com/images/portrait.webp',
      'publisher': {
        '@type': 'Organization',
        'name': 'Сергей Мавроди',
        'logo': {
          '@type': 'ImageObject',
          'url': 'https://sergey-mavrodi.com/images/images/portrait.webp',
        },
      },
      'breadcrumb': {
        '@type': 'BreadcrumbList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'name': 'Главная',
            'item': 'https://sergey-mavrodi.com/',
          },
        ],
      },
    })}
  </script>

  {/* --- Schema.org: VideoObjects --- */}
    {videos.map((video, i) => (
      <script key={i} type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'VideoObject',
          name: video.name,
          description: video.description,
          thumbnailUrl: `https://sergey-mavrodi.com${video.thumbnailUrl}`,
          uploadDate: video.uploadDate,
          duration: video.duration,
          contentUrl: `https://sergey-mavrodi.com${video.contentUrl}`,
          embedUrl: `https://sergey-mavrodi.com${video.contentUrl}`,
          publisher: {
            '@type': 'Organization',
            name: 'Сергей Мавроди',
            logo: {
              '@type': 'ImageObject',
              url: 'https://sergey-mavrodi.com/images/portrait.webp',
            },
          },
        })}
      </script>
    ))}

</Helmet>


      <h2>ГЛАВНАЯ СТРАНИЦА</h2>

      {/* КАРТИНКА */}
      <div className="media-container">
        <img
          src="/images/img7.webp"
          alt="Картина Михаила Врубеля «Демон поверженный»"
          title="Михаил Врубель. Демон поверженный"
          className="media-content img7-specific"
          width="636"
          height="139"
        />
      </div>
      

      {/* 🔹 ПЕРВОЕ ВИДЕО */}
      <div className="media-container">
        {!isFirstVideoLoaded ? (
          <div onClick={() => setIsFirstVideoLoaded(true)} className="video-preview">
            <img
              src="/video/24.webp"
              alt="Официальный сайт Сергея Мавроди"
              className="video-thumbnail"
                width="636"
                height="476"
            />
            <svg className="play-button" fill="limegreen" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        ) : (
          <video
            src="/video/24.mp4"
            className="video-player"
            controls
            autoPlay
            playsInline
          />
        )}
      </div>

      {/* 🔹 ВТОРОЕ ВИДЕО */}
      <div className="media-container">
        {!isSecondVideoLoaded ? (
          <div onClick={() => setIsSecondVideoLoaded(true)} className="video-preview">
            <img
              src="/video/42.webp"
              alt="Предупреждение от Сергея Мавроди"
              className="video-thumbnail"
                width="636"
                height="476"
            />
            <svg className="play-button" fill="limegreen" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        ) : (
          <video
            src="/video/42.mp4"
            className="video-player"
            controls
            autoPlay
            playsInline
          />
        )}
      </div>

      {/* 🔹 ПРЕДУПРЕЖДЕНИЕ */}
      <WarningMessage />
    </div>
  );
};

export default Seite;
